<form [formGroup]="measureFrequencyForm">
  <h2>How would you like to compare measurements?</h2>
  <div class="form-row">
    <mat-form-field>
      <mat-label>Comparison type</mat-label>
      <mat-select formControlName="comparitors" required>
        <mat-option *ngFor="let comparitor of comparitors" [value]="comparitor.value">
          {{ comparitor.label }}
        </mat-option>
      </mat-select>
      <mat-hint *ngIf="selectedTooltip">{{ selectedTooltip }}</mat-hint>
    </mat-form-field>
  </div>
  <ng-container *ngIf="measureFrequencyForm.get('comparitors').value !== 'fixed'">
    <h2 class="section-heading">How many days/measures should we average?</h2>
    <div class="form-row">
      <mat-form-field *ngIf="measureFrequencyForm.get('comparitors').value === 'days'; else measure">
        <mat-label>Days</mat-label>
        <input placeholder="Days" matInput formControlName="count" />
      </mat-form-field>
      <ng-template #measure>
        <mat-form-field>
          <mat-label>Measures</mat-label>
          <input placeholder="Measures" matInput formControlName="count" />
        </mat-form-field>
      </ng-template>
    </div>
  </ng-container>
</form>
